import script from "./CreateEditJobDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateEditJobDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./CreateEditJobDropdown.vue?vue&type=style&index=0&id=4d1ff643&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1ff643"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QBtn});
